/**
 * Service pour les préférences UI de l'utilisateur courant
 * (ex. nombre d'éléments par page par type de liste).
 * Aucune logique métier, uniquement des appels API.
 */

import { api, endpoints } from './api.js'

export const userPreferencesService = {
  get: () => api.get(endpoints.userPreferences.me()),

  update: (data) => api.patch(endpoints.userPreferences.me(), data),
}
